import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=5227a104&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=5227a104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227a104",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIMenuUK: require('/opt/build/repo/components/UI/MenuUK.vue').default,UIMenuUS: require('/opt/build/repo/components/UI/MenuUS.vue').default})
